import ContactDemandManagementReducer from 'store/contact/demand/reducers';

export default ContactDemandManagementReducer;
